import React from 'react'
import { Route, Switch } from 'react-router'

import {
  CWV_ROUTES,
  RouteProps,
  getAllTemplatesForVersionedRoute,
  routes,
  useFlag,
} from '@sketch/modules-common'

import PageCanvasView from 'modules/shares/PageCanvasView/PageCanvasView'
import DocumentView from 'modules/shares/DocumentView/DocumentView'
import { PrivateWorkspaceRoute } from 'modules/workspace/containers'
import { DocView } from 'modules/designSystems/pages'
import {
  DocumentSidebarLayout,
  DocumentSidebarLayoutExtraProps,
} from 'modules/shares/components/DocumentSidebarLayout'
import {
  PublicWorkspaceFragment,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'
import {
  ArtboardDetailViewFFGate,
  ArtboardDetailQueriesProps,
} from 'modules/shares/ArtboardDetailView'
import { ArtboardRevisionRedirect } from '../ArtboardRevisionRedirect'

const DocumentSidebarLayoutRoutesSwitch = (
  layoutProps: DocumentSidebarLayoutExtraProps
) => {
  const isDesignSystemsOn = useFlag('design-systems')

  return (
    <Switch>
      {/* Artboard Revisions route now redirects to versioned Artboard Detail route */}
      <Route
        exact
        path={[...getAllTemplatesForVersionedRoute('ARTBOARD_REVISION')]}
        component={ArtboardRevisionRedirect}
      />
      {/* Artboard detail view */}
      <Route
        exact
        path={[...getAllTemplatesForVersionedRoute('ARTBOARD_DETAIL')]}
        render={routeProps => (
          <ArtboardDetailViewFFGate
            {...layoutProps}
            {...(routeProps as ArtboardDetailQueriesProps)}
          />
        )}
      />

      <Route
        exact
        path={getAllTemplatesForVersionedRoute('SHARE_PAGE_CANVAS_VIEW')}
        render={routeProps => (
          <PageCanvasView
            {...layoutProps}
            {...(routeProps as RouteProps<'SHARE_VIEW'>)}
          />
        )}
      />

      <Route
        exact
        path={[
          ...getAllTemplatesForVersionedRoute('SHARE_PAGE_VIEW'),
          ...getAllTemplatesForVersionedRoute('SHARE_PROTOTYPES'),
          ...CWV_ROUTES,
        ]}
        render={routeProps => <DocumentView {...layoutProps} {...routeProps} />}
      />

      {isDesignSystemsOn && (
        <PrivateWorkspaceRoute
          exact
          path={routes.DESIGN_SYSTEM_PAGES.template()}
          render={routeProps => (
            <DocView {...routeProps} layoutProps={layoutProps} />
          )}
        />
      )}
    </Switch>
  )
}

export const DocumentSidebarLayoutRoutes = ({
  workspace,
}: {
  workspace: WorkspaceMinimalFragment | PublicWorkspaceFragment
}) => (
  <DocumentSidebarLayout
    workspace={workspace}
    render={layoutProps => (
      <DocumentSidebarLayoutRoutesSwitch {...layoutProps} />
    )}
  />
)
